import { isProd } from "../constants";
import { LeadAPI } from "../apis/LeadAPI";


// database field names
export type LeadJSON = {
  id?: string,
  key?: string,
  email?: string,
  first_name?: string,
  last_name?: string,
};

export class Lead {
  static path = isProd? "https://lead-manager.weareatticus.com/leads" : "https://lead-manager-ppd1.weareatticus.com/leads"

  constructor(
    public id?: string,
    public key?: string,
    public email?: string,
    public firstName?: string,
    public lastName?: string,
  ) {}

  // clone
  static from(lead: Lead): Lead {
    return new Lead(
      lead.id,
      lead.key,
      lead.email,
      lead.firstName,
      lead.lastName,
    );
  }

  static fromJSON = (json: LeadJSON): Lead => {
    return new Lead(
      json.id,
      json.key,
      json.email,
      json.first_name,
      json.last_name,
    );
  };

  toJson(): LeadJSON {
    return {
      id: this.id,
      key: this.key,
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
    }
  }

  async save(): Promise<Lead> {
    if(!this.key) {
      throw new Error("unable to save lead without lead key")
    }

    const leadJson = this.toJson();
    await LeadAPI.upsertLead(leadJson);
    return this;
  }
}
